export const cardNode = `
fragment cardNode on ContentItem {
    id
    url
    title
    sectionList
    sectionLabels
    relatedLinks {
        url
        title
        sourceId
    }
    deck
    description
    flag
    flags {
        status
        label
    }
    imageLarge
    image {
        _16x9_460: derivative(preferredWidth:460, aspectRatio:"16x9")  {
            w
            fileurl
        }
        _16x9_620: derivative(preferredWidth:620, aspectRatio:"16x9") {
            w
            fileurl
        }
        _16x9_940: derivative(preferredWidth:940, aspectRatio:"16x9") {
            w
            fileurl
        }
        square_220: derivative(preferredWidth:220, aspectRatio:"square") {
            w
            fileurl
        }
        aspects {
            ratio16x9 {
                url
            }
            ratio1x1 {
                url
            }
            ratio9x16 {
                url
            }
        }
    }
    source
    sourceId
    publishedAt
    updatedAt
    type
    showName
    authors {
        name
        photo {
            aspects {
                ratio1x1 {
                    url
                }
            }
        }
    }
    commentsEnabled
    contextualHeadlines {
        headline
        contextualLineupSlug
    }
    contextualOverrides {
        headline
        flag
        contextualLineupSlug
    }
    mediaId
    media {
        duration
        hasCaptions
        streamType
    }
    components {
        mainContent {
            url
            sectionList
            flag
            sourceId
            type
        }
        mainVisual {
            ... on ContentItem {
                publishedAt
                mediaId
                sourceId
                media {
                    duration
                    hasCaptions
                    streamType
                }
                title
                imageLarge
            }
        }
        primary
        secondary    
    }
    categories {
      name
      slug
      path
    }
}`;
